import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { translate } from 'react-i18next'
import moment from 'moment'
import _ from 'lodash'
import { Roles } from '../../config'

import { allowedContactFields } from '../../helpers'
import {
  selectContact,
  editContact,
  contactIsInCall,
  hubspotPutContact,
  storeTablePage,
  deleteContacts
} from '../../actions'

import { Table, Button, Tooltip, Icon, Input, Popconfirm } from 'antd'

class ContactsList extends Component {
  state = {
    filterDropdownVisible: false,
    data: this.props.data,
    searchText: '',
    filtered: false,
    selectedRowKeys: []
  }

  onSearchInputChange = e => {
    this.setState({ searchText: e.target.value })
  }

  onSearch = () => {
    const { searchText } = this.state
    const reg = new RegExp(searchText, 'gi')

    this.setState({
      filterDropdownVisible: false,
      filtered: !!searchText,
      data: this.props.data
        .map(record => {
          const match = record.company && record.company.match(reg)
          if (!match) {
            return null
          }
          return {
            ...record,
            company: (
              <span>
                {record.company.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map(
                  (text, i) =>
                    text.toLowerCase() === searchText.toLowerCase() ? (
                      <span key={i} className='highlight'>
                        {text}
                      </span>
                    ) : (
                      text
                    ) // eslint-disable-line
                )}
              </span>
            )
          }
        })
        .filter(record => !!record)
    })
  }

  handleHubspotPutContact = contact => {
    const {
      match: { params },
      user,
      hubspotPutContact,
      projects
    } = this.props

    const currentProject = projects[params.projectId]

    hubspotPutContact(params.projectId, user.idToken, contact, currentProject)
  }

  isItTooSoon = record => {
    if (record.lastCallAt) {
      if (record.nextCallDate) {
        // if user has specified 'nextCallDate', compare with current datetime
        return moment(record.nextCallDate).isAfter(moment())
      }
      // cannot call twice in one day
      return moment(record.lastCallAt).isSame(moment(), 'day')
    }
  }

  handleActionClick = (action, contact) => {
    const { selectContact } = this.props

    selectContact(action, contact.id)

    // if somebody clicked on Call button, save this information into DB
    if (action === 'call') {
      const {
        match: { params },
        contactIsInCall
      } = this.props
      contactIsInCall(true, contact.id, params.projectId)
    }
  }

  onTablePageChange = page => {
    const { storeTablePage } = this.props

    storeTablePage(page.current)
  }

  onRowsSelectChange = selectedRowKeys => {
    this.setState({ selectedRowKeys })
  }

  confirmDeleteContacts = () => {
    const {
      match: { params },
      deleteContacts
    } = this.props

    const contactIds = this.state.selectedRowKeys

    deleteContacts(params.projectId, contactIds)
  }

  render () {
    // console.log('  RENDER: ContactsList')

    const {
      t,
      match: { params },
      projects,
      loading,
      nav,
      user
    } = this.props

    const currentProject = projects[params.projectId]

    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onChange: this.onRowsSelectChange
    }

    const columns = [
      {
        title: '',
        dataIndex: 'operation',
        width: 125,
        fixed: 'left',
        render: (text, record) => {
          return (
            <div className='editable-row-operations'>
              <Button
                style={{ marginRight: 5 }}
                type='primary'
                icon='edit'
                onClick={() => this.handleActionClick('edit', record)}
              />

              {/* if status NOT 'appointment/dropOff/notReached/successfullyReached' and Contact is not in call */}
              {![12, 13, 14, 15].includes(record.status) && (
                <span>
                  {!this.isItTooSoon(record) ? ( // disable call button when 'record.lastCallAt' is today
                    <Tooltip title={record.isInCall && 'this Contact is currently in call'}>
                      <Button
                        type='primary'
                        icon='phone'
                        onClick={() => this.handleActionClick('call', record)}
                        style={{
                          background: record.isInCall ? '#ccc' : '#007e00',
                          borderColor: record.isInCall ? '#ccc' : '#007e00',
                          marginRight: 5
                        }}
                        disabled={record.isInCall}
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip
                      title={`next call possible: ${
                        record.nextCallDate
                          ? moment(parseInt(record.nextCallDate, 10)).format('MMMM Do YYYY, HH:mm')
                          : 'tomorrow'
                      }`}
                    >
                      <Icon type='info-circle' style={{ marginLeft: 10 }} />
                    </Tooltip>
                  )}
                </span>
              )}

              {[11, 12, 15].includes(record.status) && currentProject.usedIntegrations.hubspot && (
                <Tooltip title={!record.email && 'cannot sync with HubSpot, Email is missing'}>
                  <Button
                    icon='sync'
                    type='primary'
                    loading={loading.hubspotPutContact}
                    onClick={() => this.handleHubspotPutContact(record)}
                    style={{
                      background: !record.email ? '#ccc' : '#FF7A59',
                      borderColor: !record.email ? '#ccc' : '#FF7A59'
                    }}
                    disabled={!record.email}
                  />
                </Tooltip>
              )}
            </div>
          )
        }
      }
    ]

    const contactFieldsNotVisibleAsColumns = [] // fields that will not be visible in table

    const columnSearchProps = {
      filterIcon: <Icon type='search' style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }} />,
      filterDropdownVisible: this.state.filterDropdownVisible,
      onFilterDropdownVisibleChange: visible => {
        this.setState(
          {
            filterDropdownVisible: visible
          },
          () => this.searchInput && this.searchInput.focus()
        )
      },
      filterDropdown: (
        <div className='custom-filter-dropdown'>
          <Input
            ref={ele => (this.searchInput = ele)}
            placeholder='Search Company'
            value={this.state.searchText}
            onChange={this.onSearchInputChange}
            onPressEnter={this.onSearch}
          />
          <Button type='primary' onClick={this.onSearch}>
            Search
          </Button>
        </div>
      )
    }

    allowedContactFields.forEach(field => {
      !contactFieldsNotVisibleAsColumns.includes(field.name) &&
        columns.push({
          title: t(`contact.fields.${field.name}`),
          dataIndex: field.name,
          key: field.name,
          width: field.columnWidth,
          // sorter: (a, b) => a[field.name].localeCompare(b[field.name])

          // include search function for 'company' column
          ...(field.name === 'company' ? { ...columnSearchProps } : {})
        })
    })

    // compute table max width - needed for antd Table, so that horizontal scrolling works correctly
    const tableMaxWidth = columns[0].width + _.sumBy(allowedContactFields, 'columnWidth')

    // check if there are any selected rows
    const hasSelected = this.state.selectedRowKeys.length > 0

    // get my Project role
    const myProjectRole = user.projectsRoles[params.projectId]

    return (
      <div>
        {myProjectRole < Roles.PROJECT.MANAGER && (
          <Popconfirm
            title='Do you really want to delete selected Contacts?'
            onConfirm={() => this.confirmDeleteContacts()}
            okText='Yes'
            cancelText='No'
          >
            <Button icon='delete' type='danger' disabled={!hasSelected} style={{ marginBottom: 10 }}>
              Delete Contacts ({this.state.selectedRowKeys.length})
            </Button>
          </Popconfirm>
        )}

        <Table
          bordered
          columns={columns}
          dataSource={this.state.data}
          rowKey='id'
          rowClassName={record =>
            ![12, 13, 14, 15].includes(record.status) && this.isItTooSoon(record) ? 'too-soon' : ''
          }
          size='small'
          pagination={{ defaultCurrent: nav.page, simple: true }}
          scroll={{ x: tableMaxWidth, y: 600 }}
          onChange={this.onTablePageChange}
          rowSelection={myProjectRole < Roles.PROJECT.MANAGER && rowSelection}
        />
      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  nav: state.nav,
  user: state.user,
  projects: state.projects,
  loading: state.loading
})

const mapDispatchToProps = {
  selectContact,
  editContact,
  contactIsInCall,
  hubspotPutContact,
  storeTablePage,
  deleteContacts
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(translate('translations')(ContactsList)))



// WEBPACK FOOTER //
// ./src/components/Contacts/ContactsList.js